<template>
  <section id="partners" class="partners section-card">
    <p class="label label-tight">Our Partners</p>
    <div class="partners-carousel">
      <div class="partners-track">
        <template v-for="item in carouselItems">
          <img
            v-if="item.type === 'logo'"
            :key="`logo-${item.id}`"
            :src="item.src"
            :alt="item.alt"
            class="partner-logo"
            :class="item.logoClass"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import visibleHandsLogo from '../assets/landing2/visible-hands-logo.svg';
import intuitLogo from '../assets/landing2/intuit-logo.svg';
import microsoftLogo from '../assets/landing2/microsoft-logo.webp';
import communitasAmericaLogo from '../assets/landing2/communitasAmerica.svg';
import nycEdcLogo from '../assets/landing2/NYCEDC.svg';
import nationUrbanLeagueLogo from '../assets/landing2/NationalUrbanLeague.png';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2Partners',
  data() {
    return {
      partnerLogos: [
        {
          src: visibleHandsLogo,
          alt: 'Visible Hands',
          logoClass: 'partner-logo--visible-hands',
        },
        {
          src: intuitLogo,
          alt: 'Intuit',
          logoClass: 'partner-logo--intuit',
        },
        {
          src: microsoftLogo,
          alt: 'Microsoft for Startups',
          logoClass: 'partner-logo--microsoft',
        },
        {
          src: communitasAmericaLogo,
          alt: 'Communitas America',
          logoClass: 'partner-logo--communitas',
        },
        {
          src: nycEdcLogo,
          alt: 'NYC EDC',
          logoClass: 'partner-logo--nycedc',
        },
        {
          src: nationUrbanLeagueLogo,
          alt: 'National Urban League',
          logoClass: 'partner-logo--nationalUrbanLeague',
        },
      ],
    };
  },
  computed: {
    carouselItems() {
      const items = [];
      this.partnerLogos.forEach((partner) => {
        items.push({ type: 'logo', ...partner });
        items.push({ type: 'divider' });
      });
      // duplicated so the track can loop seamlessly at -50%
      return [...items, ...items].map((item, index) => ({ ...item, id: index }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.partners {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.75rem;
  height: 12.1875rem;
  padding: 0 4rem;
}

.partners-carousel {
  overflow: hidden;
  width: 100%;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}

.partners-track {
  display: flex;
  align-items: center;
  width: max-content;
  animation: partners-scroll 28s linear infinite;
}

.partners-carousel:hover .partners-track {
  animation-play-state: paused;
}

@keyframes partners-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.partner-logo {
  flex: 0 0 auto;
  height: 3rem;
  width: auto;
  margin-right: 8rem;
  object-fit: contain;
}

@media (max-width: 767px) {
  .partners {
    height: 10.5rem;
    padding: 0;
  }

  .partners .label {
    display: none;
  }

  .partner-logo {
    height: 2.5rem;
    margin-right: 4rem;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .partners {
    height: fluid(10.5rem, 12.1875rem);
    padding: 0 fluid(0rem, 4rem);
  }

  .partner-logo {
    height: fluid(2.5rem, 3rem);
    margin-right: fluid(4rem, 8rem);
  }
}
</style>
